import Button from 'components/ui/Button/Button';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <div className="text-center" style={{ marginBottom: 100 }}>
      <div style={{ fontSize: 170, marginBlock: '100px 50px' }}>404</div>
      <div className="text-md mb-10">Page was not found</div>
      <Button className="btn btn-primary mt-30" title="Go Home" onClick={() => navigate('/')} />
    </div>
  );
};

export default NotFoundPage;
